<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <h5>General information</h5>

        <div class="form-group">
          <label for="premise.title">Title</label>
          <ValidationProvider name="title" vid="title" v-slot="{ errors }" rules="required">
            <input class="form-control" v-model="premise.title" :class="{ 'is-invalid': errors[0] }">
            <span class="text-danger">{{errors[0]}}</span>
          </ValidationProvider>
        </div>

        <div class="form-group">
          <label for="premise.taxNumber">Tax number</label>
          <ValidationProvider name="tax number" vid="premise.taxNumber" v-slot="{ errors }" rules="required">
            <input class="form-control" v-model="premise.taxNumber" :class="{ 'is-invalid': errors[0] }">
            <span class="text-danger">{{errors[0]}}</span>
          </ValidationProvider>
        </div>

        <div class="form-group">
          <label for="premise.label">Label</label>
          <ValidationProvider name="label" vid="premise.label" v-slot="{ errors }" rules="required">
            <input class="form-control" v-model="premise.label" :class="{ 'is-invalid': errors[0] }">
            <span class="text-danger">{{errors[0]}}</span>
          </ValidationProvider>
        </div>

        <div class="form-group">
          <label for="premise.description">Description</label>
          <ValidationProvider name="description" vid="premise.description" v-slot="{ errors }" rules="required">
            <textarea class="form-control" v-model="premise.description" rows="3" :class="{ 'is-invalid': errors[0] }"></textarea>
            <span class="text-danger">{{errors[0]}}</span>
          </ValidationProvider>
        </div>

        <hr>
        <h5>Address information</h5>

        <div class="row">
          <div class="form-group col-md-8">
            <label for="premise.address.street">Street</label>
            <ValidationProvider name="street" vid="premise.address.street" v-slot="{ errors }" rules="required">
              <input class="form-control" v-model="premise.address.street" :class="{ 'is-invalid': errors[0] }">
              <span class="text-danger">{{errors[0]}}</span>
            </ValidationProvider>
          </div>

          <div class="form-group col-md-2">
            <label for="premise.address.houseNumber">House number</label>
            <ValidationProvider name="house number" vid="premise.address.houseNumber" v-slot="{ errors }" rules="required">
              <input class="form-control" v-model="premise.address.houseNumber" :class="{ 'is-invalid': errors[0] }">
              <span class="text-danger">{{errors[0]}}</span>
            </ValidationProvider>
          </div>

          <div class="form-group col-md-2">
            <label for="premise.address.additionalNumber">Additional number</label>
            <ValidationProvider name="additional number" vid="premise.address.additionalNumber" v-slot="{ errors }">
              <input class="form-control" v-model="premise.address.additionalNumber" :class="{ 'is-invalid': errors[0] }">
              <span class="text-danger">{{errors[0]}}</span>
            </ValidationProvider>
          </div>

        </div>

        <div class="row">
          <div class="form-group col-md-4">
            <label for="premise.address.postalCode">Postal code</label>
            <ValidationProvider name="postal code" vid="premise.address.postalCode" v-slot="{ errors }" rules="required">
              <input class="form-control" v-model="premise.address.postalCode" :class="{ 'is-invalid': errors[0] }">
              <span class="text-danger">{{errors[0]}}</span>
            </ValidationProvider>
          </div>

          <div class="form-group col-md-8">
            <label for="premise.address.city">City</label>
            <ValidationProvider name="city" vid="premise.address.city" v-slot="{ errors }" rules="required">
              <input class="form-control" v-model="premise.address.city" :class="{ 'is-invalid': errors[0] }">
              <span class="text-danger">{{errors[0]}}</span>
            </ValidationProvider>
          </div>
        </div>

        <div class="form-group">
          <label for="premise.address.community">Community</label>
          <ValidationProvider name="community" vid="premise.address.community" v-slot="{ errors }" rules="required">
            <input class="form-control" v-model="premise.address.community" :class="{ 'is-invalid': errors[0] }">
            <span class="text-danger">{{errors[0]}}</span>
          </ValidationProvider>
        </div>

        <hr>
        <h5>Cadastral information</h5>

        <div class="form-group">
          <label for="premise.property.cadastralNumber">Cadastral community number</label>
          <ValidationProvider name="cadastral community number" vid="premise.property.cadastralNumber" v-slot="{ errors }" rules="required">
            <input class="form-control" v-model="premise.property.cadastralNumber" :class="{ 'is-invalid': errors[0] }">
            <span class="text-danger">{{errors[0]}}</span>
          </ValidationProvider>
        </div>

        <div class="form-group">
          <label for="premise.property.buildingNumber">Building number</label>
          <ValidationProvider name="building number" vid="premise.property.buildingNumber" v-slot="{ errors }" rules="required">
            <input class="form-control" v-model="premise.property.buildingNumber" :class="{ 'is-invalid': errors[0] }">
            <span class="text-danger">{{errors[0]}}</span>
          </ValidationProvider>
        </div>

        <div class="form-group">
          <label for="premise.property.buildingSectionNumber">Building part number</label>
          <ValidationProvider name="building part number" vid="premise.property.buildingSectionNumber" v-slot="{ errors }" rules="required">
            <input class="form-control" v-model="premise.property.buildingSectionNumber" :class="{ 'is-invalid': errors[0] }">
            <span class="text-danger">{{errors[0]}}</span>
          </ValidationProvider>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Premise',
  data: () => ({
    'premise': {
      "_id":"7b98a33a-cd31-46a8-ae36-9e53aa3c58e2",
      "title":"Inter-es d.o.o.",
      "address":{
        "street":"Cesta na Brdo",
        "houseNumber": 85,
        "community":"Ljubljana",
        "city":"Ljubljana",
        "postalCode":1000
      },
      "description":"Poslovni prostor cesta na Brdo",
      "label":"interes",
      "property":{
        "cadastralNumber":1723,
        "buildingNumber":291,
        "buildingSectionNumber":21
      },
      "taxNumber":10554254,
      "certificate":{
        "password":"H407KFCWVVOF",
        "name":"10554254-1.p12"
      }
    }
  }),
};
</script>
